import { Injectable, signal } from '@angular/core';
import { NetworkStatusPort } from './network-status.port';

// Browser-native implementation of NETWORK_STATUS (moved from
// libs/activations/.../services/network-status.service.ts). Same public shape
// as the native provider — a readonly `isOnline` signal + an `initialize()`
// method kept for API parity. Because navigator.onLine + online/offline events
// are synchronous, this service self-initializes in its constructor — no
// consumer needs to remember to call initialize().
@Injectable({ providedIn: 'root' })
export class WebNetworkStatusService implements NetworkStatusPort {
  private readonly _isOnline = signal(navigator.onLine);
  readonly isOnline = this._isOnline.asReadonly();

  constructor() {
    window.addEventListener('online', () => this._isOnline.set(true));
    window.addEventListener('offline', () => this._isOnline.set(false));
  }

  // Idempotent, no-op-safe: kept for API-shape parity with the native
  // provider's async initialize(). Re-syncs from navigator.onLine on demand.
  initialize(): void {
    this._isOnline.set(navigator.onLine);
  }
}
